import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#0B1F3A] py-4 px-3 text-center border-t-4 border-[#FF6B00]" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <p className="font-black text-white mb-1 text-base uppercase tracking-widest" data-id="element-47">
          🏋️ KIT COMPLETO FUNCIONAL LISTO
        </p>
        <p className="text-gray-400 font-bold text-xs mb-2 uppercase" data-id="element-48">
          © 2026 Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4 text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-49">
          <span className="cursor-pointer hover:text-[#FF6B00] transition-colors" data-id="element-50">
            Términos y Condiciones
          </span>
          <span className="cursor-pointer hover:text-[#FF6B00] transition-colors" data-id="element-51">
            Políticas de Privacidad
          </span>
        </div>
      </div>
    </footer>;
}